export const createEmptyFeedback = () => ({error: '', success: ''});

export const createEmptyPagination = () => ({
    page: 0,
    page_size: 10,
    total: 0,
    total_pages: 1,
    has_next: false,
    has_previous: false,
});

const getTotalFrom = (source, fallback = 0) => (
    source?.pagination?.total
    ?? source?.pagination?.totalItems
    ?? source?.pagination?.total_elements
    ?? source?.meta?.total
    ?? source?.meta?.total_items
    ?? source?.total
    ?? source?.totalElements
    ?? source?.count
    ?? fallback
);

const getItemsFrom = (payload) => {
    if (Array.isArray(payload)) return {items: payload, total: payload.length};

    const collections = ['items', 'data', 'content', 'results', 'registros', 'conteudo'];
    for (const key of collections) {
        if (Array.isArray(payload?.[key])) {
            return {
                items: payload[key],
                total: getTotalFrom(payload, payload[key].length),
            };
        }
    }

    return {items: [], total: 0};
};

export const extractListPayload = (response) => {
    const root = response?.data ?? {};
    const payload = root?.valor ?? root;
    const result = getItemsFrom(payload);

    if (result.items.length || Array.isArray(payload)) return result;
    if (payload !== root) {
        const rootResult = getItemsFrom(root);
        if (rootResult.items.length) return rootResult;
    }
    return getItemsFrom(root?.data);
};

export const extractPagePayload = (response) => {
    const payload = response?.data ?? {};
    const nestedItems = payload?.data;
    const items = Array.isArray(nestedItems)
        ? nestedItems
        : Array.isArray(payload?.items)
            ? payload.items
            : Array.isArray(payload)
                ? payload
                : [];

    const page = Number(payload?.page ?? payload?.pagination?.page ?? 0);
    const totalPages = Number(payload?.totalPages ?? payload?.pagination?.total_pages ?? 1);

    return {
        items,
        pagination: {
            page,
            page_size: Number(payload?.limit ?? payload?.size ?? payload?.pageSize ?? payload?.page_size ?? payload?.pagination?.page_size ?? payload?.pagination?.size ?? items.length),
            total: Number(payload?.total ?? payload?.pagination?.total ?? items.length),
            total_pages: totalPages,
            has_next: payload?.hasNext ?? payload?.pagination?.has_next ?? page + 1 < totalPages,
            has_previous: payload?.hasPrevious ?? payload?.pagination?.has_previous ?? page > 0,
        },
    };
};
